// extracted by mini-css-extract-plugin
module.exports = {"addToCart":"AddToCart_addToCart__htbI_","wellaStore":"AddToCart_wellaStore__CKfPg"};